import React from 'react';
import {HomeGameCardItem, HomeGameFloorItem} from '../home.type';
// import {View} from 'react-native';
// import HomeCategory from '@/components/business/home-category/home-category';
// import {goTo} from '@/utils';
import globalStore from '@/services/global.state';
import {UserGroup} from '../../promotions/type';
import PromotionCard from '@/pages/promotions/promotion-card';
import {goTo} from '@/utils';

// 1. 抽取常量
// const SLIDE_WIDTHS = {
//   PROMOTION: 0.48,
//   GAME: 0.28,
//   SPORTS: '19rem',
// };

// 2. 抽取渲染逻辑
const renderPromotionSection = (
  floor: HomeGameFloorItem,
  userGroupList: UserGroup[],
  screenWidth?: number,
) => {
  // const swiperWidth =
  //   userGroupList.length <= 2
  //     ? screenWidth
  //     : screenWidth * SLIDE_WIDTHS.PROMOTION;
  console.log('screenWidth', screenWidth);
  if (!floor?.gamesList) {
    return null;
  }
  const filteredGameList = floor?.gamesList?.filter(_game => {
    const game = _game as HomeGameCardItem;
    return userGroupList.some(
      group => group.id.toString() === game.tripartiteUniqueness,
    );
  });

  if (filteredGameList?.length === 0) {
    return null;
  }

  if (filteredGameList?.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-row gap-[9px] px-2 mb-3">
      {floor.gamesList?.map(_v => {
        const v = _v as HomeGameCardItem;
        return (
          <div
            key={v.id}
            // 活动卡片调转地址
            onClick={() => goTo('PromotionsV2', {tabKey: 'promotion'})}>
            <PromotionCard
              style={{width: '10.94rem', height: '5rem'}}
              key={v.id}
              type={'Promotion'}
              expired={false}
              bg={v.gamePic}
              login={!!globalStore.token}
              noJoin={true}
            />
          </div>
        );
      })}
    </div>
    // <div className="mb-3">
    //   <HomeCategory
    //     key={floor.id}
    //     title={floor.name}
    //     icon={floor.categoryPic}
    //     list={filteredGameList}
    //     swiperSlideWidth={swiperWidth}
    //     renderItem={card => (
    //       <div onClick={() => goTo('PromotionsV2', {tabKey: 'promotion'})}>
    //         <PromotionCard
    //           style={{width: swiperWidth, height: 80}}
    //           key={card.id}
    //           type={'Promotion'}
    //           expired={false}
    //           bg={card.gamePic}
    //           login={!!globalStore.token}
    //           noJoin={true}
    //         />
    //       </div>
    //     )}
    //   />
    // </div>
  );
};

export default renderPromotionSection;
